// src/components/ActiveDealsPerformance.js
import React from 'react';

const ActiveDealsPerformance = () => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-gray-800">Active Deals Performance</h2>
        <a href="#" className="text-orange-500 hover:underline text-sm font-medium">View All</a>
      </div>

      {/* Deal Item */}
      <div className="flex items-center justify-between p-4 bg-gray-50 rounded-md border border-gray-200">
        <div>
          <p className="text-gray-900 font-medium">Summer Wellness Package</p>
          <p className="text-gray-600 text-sm">45 sales &bull; ₹3,550</p>
          <p className="text-red-500 text-xs mt-1">Expires in 3 days</p>
        </div>
        <div>
          <span className="text-gray-400">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
              ></path>
            </svg>
          </span>
        </div>
      </div>

      {/* You can add more deal items here */}
    </div>
  );
};

export default ActiveDealsPerformance;